import React from 'react';
import { Link } from 'react-router-dom';
import PageShell from '../Components/ui/PageShell';
import { useLayout } from '../layout/AppLayout';

function ClientsHub() {
  const { openFormModal } = useLayout();

  return (
    <PageShell
      title="Clients"
      subtitle="Add new clients or open the client list to manage accounts and assign team leads or recruiters."
      breadcrumbs={[
        { label: 'Dashboard', path: '/dashboard' },
        { label: 'Clients' },
      ]}
      backTo="/dashboard"
    >
      <div className="hr-dashboard-grid">
        <button type="button" className="hr-dashboard-card hr-dashboard-card-btn" onClick={() => openFormModal('create-client')}>
          <h3>Add Client</h3>
          <p>Register a new client organization</p>
        </button>
        <Link to="/clients/list" className="hr-dashboard-card">
          <h3>Client List</h3>
          <p>Browse clients, assign users, import and export</p>
        </Link>
      </div>
    </PageShell>
  );
}

export default ClientsHub;
